import MuiButton from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import {spacing} from '@mui/system';

const Button = styled(MuiButton)(spacing);

export default Button;
